/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Plan
 */
export interface Plan {
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    discount?: number;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    id?: number;
    stripeProductId?: string;
}

/**
 * Check if a given object implements the Plan interface.
 */
export function instanceOfPlan(value: object): value is Plan {
    return true;
}

export function PlanFromJSON(json: any): Plan {
    return PlanFromJSONTyped(json, false);
}

export function PlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): Plan {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'discount': json['discount'] == null ? undefined : json['discount'],
        'id': json['id'] == null ? undefined : json['id'],
        'stripeProductId': json['stripeProductId'] == null ? undefined : json['stripeProductId'],
    };
}

export function PlanToJSON(json: any): Plan {
    return PlanToJSONTyped(json, false);
}

export function PlanToJSONTyped(value?: Plan | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'amount': value['amount'],
        'discount': value['discount'],
        'id': value['id'],
        'stripeProductId': value['stripeProductId'],
    };
}

